<div class="wt-bnr-inr overlay-wraper bg-center" 
    [ngStyle]="{
        'background-image': 'url(' + backgroundImage + ')', 
        'background-size': 'cover', 
        'background-position': 'center'
       
    }">
    <div class="overlay-main" style="background-color: rgba(240, 240, 240, 0.5);"></div>
    <div class="container">
        <div class="wt-bnr-inr-entry">
            <div class="banner-title-outer">
                <div class="banner-title-name">
                    <h4 style="color: #333;">{{title}}</h4>
                </div>
            </div>
            <!-- BREADCRUMB ROW -->

            <!-- <div>
                <ul class="wt-breadcrumb breadcrumb-style-2">
                    <li><a routerLink="/index" style="color: #333;">Home</a></li>
                    <li>{{subtitle}}</li>
                </ul>
            </div> -->

            <!-- BREADCRUMB ROW END -->
        </div>
    </div>

    

    
</div>
